import AgentCall from "../agent.call/agent.call";

export const isNode = (o) =>{
    return (
        typeof Node === "object" ? o instanceof Node :
            o && typeof o === "object" && typeof o.nodeType === "number" && typeof o.nodeName==="string"
    );
}

export const isVideoSrc = (src) => {
    return src.match(/(mov|avi|wmv|flv|3gp|mp4|mpg)_$/);
}

export const limitSize = (size, maximumPixels=getMaxTextureSize()) => {
    const { width, height } = size;

    const requiredPixels = width * height;

    if (requiredPixels <= maximumPixels) return { width, height };

    const scalar = Math.sqrt(maximumPixels) / Math.sqrt(requiredPixels);
    return {
        width: Math.floor(width * scalar),
        height: Math.floor(height * scalar),
    };
}

export const clearStopVideo = (src) => {
    if(isVideoSrc(src)) return `${src.substring(0, src.length - 1)}`;

    return src;
}

export const getMaxTextureSize = () => {
    var canvas = document.createElement('canvas');
    var gl = canvas.getContext('webgl') || canvas.getContext('experimental-webgl');
    if (!gl) {
        console.error('WebGL not supported');
        return;
    }
    var maxTextureSize = gl.getParameter(gl.MAX_TEXTURE_SIZE);

    return maxTextureSize * maxTextureSize * 4;
}

export const addVideoBubble = (video) => {
    const bubble = AgentCall.prepareBubbleBody();
    bubble.querySelector('.video-tag').appendChild(video);
    bubble.style.position = 'absolute';
    bubble.style.top = 0;

    return bubble;
}

export const setVoiceOverFocus = (element) => {
    var focusInterval = 10; // ms, time between function calls
    var focusTotalRepetitions = 10; // number of repetitions
  
    element.setAttribute('tabindex', '0');
    element.blur();
  
    var focusRepetitions = 0;
    var interval = window.setInterval(function() {
      element.focus();
      focusRepetitions++;
      if (focusRepetitions >= focusTotalRepetitions) {
        window.clearInterval(interval);
      }
    }, focusInterval);
  }
